import { initializeAuth } from "./auth";
import { useSDKConfigStore } from "../stores/sdkConfigStore";
import { dataFetcher } from "../core/dataFetcher";
import { SwypeSDKConfig } from "./types";
import { useKycStore } from "../stores/useKycStore";

// Initialize SDK with configuration and pre-generated auth signature
export async function initializeSwypeSDK(
  config: SwypeSDKConfig
): Promise<void> {
  console.log("first initializeSwypeSDK called with config:", config);

  // Store config in global store
  const { setConfig } = useSDKConfigStore.getState();
  const { setIsSumsubProfileVerified } = useKycStore.getState();
  setConfig({
    eoaAddress: config.eoaAddress,
    apiKey: config.apiKey,
    baseUrl: config.baseUrl,
    apiPath: config.apiPath,
    chainID: config.chainID,
  });

  try {
    // Initialize authentication with pre-generated signature
    await initializeAuth(config.eoaAddress, {
      signature: config.signature,
      deadline: config.deadline,
    });

    console.log("SwypeSDK initialized successfully");

    // Now that authentication is complete, fetch all data
    setIsSumsubProfileVerified(false);
    await dataFetcher.fetchDataAfterAuth();
  } catch (error) {
    console.error("Failed to initialize SwypeSDK:", error);
    throw error;
  }
}
